import {getPriceWithCurrency} from "./helpers";
import store from "../store";

/**
 *
 * @param price {string|number|null}
 * @param feature {featureInterface}
 * @param fabricatorData {object}
 * @param messages {object} intl messages object (t obe able to use in the receipt)
 * @return {string}
 */
export const getPriceWithIncluded = (price, feature, fabricatorData, messages) => {
  if (price) {
    return getPriceWithCurrency(fabricatorData.settings, price, feature, false)
  }
  if (feature && fabricatorData.isLowes && (feature.partId === "center_island_sink" || feature.partId === "sink")) {
    return messages["navItem.priceNotIncluded"]
  }
  return messages["navItem.priceIncluded"]
}

/**
 * returns actual price property
 * @param feature {featureInterface}
 * @param fabricatorSettings {object}
 * @return {string|number|null}
 */
export const getFeaturePriceProperty = (feature, fabricatorSettings = null) => {
  let settings = fabricatorSettings;
  if (!settings) {
    settings = store.getState().fabricatorState.settings;
  }
  if (settings.useFabricatorCostPrices) { // show fabricator prices instead of retail prices
    return feature.dbFeature.price
  }
  if (settings.showSalePrices && (typeof feature.dbFeature.fabricatorCost == "number") && (feature.dbFeature.fabricatorCost > 0)) {
    return feature.dbFeature.fabricatorCost
  }
  return feature.dbFeature.cost
}


/**
 *
 * @param fabricatorData {object}
 * @param forTotal {boolean}
 * @return {boolean}
 */
export const getShowPrice = (fabricatorData, forTotal = false) => {
  const fabricatorSettings = fabricatorData.settings;
  if (forTotal) {
    return fabricatorSettings.showPricing && !fabricatorData.hidePricesFromUser;
  }
  return fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !fabricatorData.hidePricesFromUser;
};

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 *
 * @param price {number}
 * @param markUpValue {number}
 * @param markUpType {"mark_up"|"mark_down"|undefined}
 * @return {number}
 */
const getMarkUpPrice = (price, markUpValue, markUpType) => {
  const percentCost = price * markUpValue / 100;
  return markUpType === "mark_down" ? price - percentCost : price + percentCost
}

/**
 *
 * @param price {number}
 * @param markUpLogic {markUpLogic}
 * @param fabricatorSettings {object}
 * @return {number}
 */
export const updatePriceWithMarkUp = (price, markUpLogic, fabricatorSettings) => {
  if (!price || !markUpLogic) {
    return price
  }
  if (fabricatorSettings && fabricatorSettings.useFabricatorCostPrices) {
    if (markUpLogic.cost && markUpLogic.cost.value) {
      return getMarkUpPrice(price, markUpLogic.cost.value, markUpLogic.cost.type)
    }
  } else if (fabricatorSettings && fabricatorSettings.showSalePrices) {
    if (markUpLogic.discounts && markUpLogic.discounts.value) {
      return getMarkUpPrice(price, markUpLogic.discounts.value, markUpLogic.discounts.type)
    }
  } else if (markUpLogic.retail && markUpLogic.retail.value) {
    return getMarkUpPrice(price, markUpLogic.retail.value, markUpLogic.retail.type)
  }
  return price
}

export const parseMarkUp = (markUpString) => {
  if (!markUpString) {
    return ""
  }
  let globalMarkUp = JSON.parse(markUpString);
  if (typeof globalMarkUp === "object" && (globalMarkUp != null)) {
    // {retail: {value: "10", type: "mark_up"}} -> {retail: {value: 10, type: "mark_up"}}
    Object.keys(globalMarkUp).forEach(key => {
      if ((typeof globalMarkUp[key] === "object") && globalMarkUp[key].value) {
        globalMarkUp[key].value = +globalMarkUp[key].value;
      }
    });
    if (globalMarkUp.isUpdatedInJobBoard) {
      delete globalMarkUp.isUpdatedInJobBoard // we don't need this property anymore, once we save the job - it should be erased
    }
  }
  return globalMarkUp
}
